import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuCapacityView } from "src/tenantCustomizations/tenants/mellano/views/luukku/metrics/MellanoLuukkuCapacityView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/capacity")({
	staticData: { title: "Kapasiteetti", legacyViewKey: "mellanoLuukkuCapacityView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuCapacityView />;
}
